import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import useAlert from "@hooks/useAlert";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Box,
  Typography,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styled from 'styled-components';
import WebService from '../util/webService';
import useSnackbar from '../hooks/useSnackbar';
import { setAccount } from '../redux/actions/accountAction';
import { isAdmin, isStringNullOrEmpty } from '../util/helper';
import useIndicator from "@hooks/useIndicator";
import { useTheme } from '@mui/material/styles';
import { isExpired, decodeToken } from "react-jwt";
import codeGroupReducer from '@redux/reducers/codeGroupReducer';
import { processLogin } from '@pages/LoginPage';

// mui의 css 우선순위가 높기때문에 important를 설정 - 실무하다 보면 종종 발생 우선순위 문제
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

//
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;


const NaverCallback = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {alert, renderAlert} = useAlert()

  // const processLogin = async(data) => {
  //   const url = `/oauth/naver/login`
  //   const resp = await WebService.post(url, data)
  //   if (resp.repCode !== 'ack') {
  //     console.log('error=>', resp.repMessage)
  //     alert(resp.repMessage)
  //     return
  //   }

  //   // 공통
  //   const repMessage = JSON.parse(resp.repMessage)
  //   const account = JSON.parse(repMessage.account)
  //   dispatch(setAccount(account))

  //   const token = repMessage.token
  //   const decoded = decodeToken(token)

  //   const accessToken = repMessage.accessToken
  //   localStorage.setItem('accessToken',accessToken)

  //   const refreshToken = repMessage.refreshToken
  //   localStorage.setItem('refreshToken', refreshToken)

  //   const deviceId = repMessage.deviceId
  //   localStorage.setItem('deviceId', deviceId )

  //   if(window.opener) {
  //     window.opener.postMessage('login_success', window.location.origin)
  //     window.close()
  //   }
  // }


  useEffect( () => {
    console.log('href=>', window.location.href)
    console.log('hash=>', window.location.hash)

    const query = window.location.href.split("?")[1]
    const queryParams = query.split("&");
    const data = {};
    queryParams.forEach((param) => {
      const [key, value] = param.split("=")
      data[key] = value
    })
    window.opener.postMessage(data, window.location.origin)
    window.close()
  }, [])
  
  return(
    <>
      {renderAlert()}
      <h1>인증 중...</h1>
    </>
    
  )
}

export default NaverCallback